<template>
    <van-popup v-model:show="show" @close="close" position="bottom" :style="{
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }">
        <div class="popupContainer">
            <van-row class="headBar">
                <van-col span="5">
                    <div class="logo">
                        <img src="@/assets/themetwo/logo2-2.png" alt="">
                    </div>
                </van-col>
                <van-col span="15" style="padding: 10px;">
                    <div class="text1">{{ $t('pwa.text1') }}</div>
                    <div class="text2">{{ $t('pwa.text2') }}</div>
                </van-col>
                <van-col span="1" offset="3">
                    <div class="closeIcon">
                        <img src="@/assets/themetwo/Close_02-1.png" alt="" @click="close">
                    </div>
                </van-col>
            </van-row>
            <div style="padding: 0 20px;">
                <div class="title">{{ $t('pwa.title') }}</div>
                <div class="infoText">
                    <p style="white-space: pre-line;">
                        {{ activityInfo }}</p>
                </div>
                <div class="bonusBar" @click="handlePlayStore">
                    <img src="@/assets/themetwo/downloadApp.png" alt="">
                    <div>{{ $t('pwa.bonuses') }} <span>R$ {{ rewardCoin }}</span></div>
                    <div class="floatImage">
                        <img src="@/assets/themetwo/Button_Icon_01.png" alt="">
                    </div>
                </div>
            </div>

            <div style="padding: 15px;">
                <div class="title2">{{ $t('pwa.installIntroTitle') }}</div>
                <div class="installInfo" v-html=" $t('pwa.installIntro1')"></div>


                <div class="introCard">
                    <div class="title3">{{ $t('pwa.installIntroTitle') }}</div>
                    <div class="installInfo2">{{ $t('pwa.installIntro2') }}</div>
                </div>
            </div>


        </div>

    </van-popup>
    <ContactServicePopup ref="contactRef" />
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, PropType, computed, defineProps, watch } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { getNextTimeSlot } from '@/utils/commonFunction';
import { getPWADomain } from '@/api/common';
import { Capacitor } from '@capacitor/core';
import { goToPlayStore, openPopup, closePopup } from '@/view/components/supportFunction';

const { t } = useI18n();
const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const activityInfo = computed(() => userStore?.PWAConvertData?.config?.popupMessage)
const contactRef = ref()
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const rewardCoin = computed(() => userStore?.PWAConvertData?.config?.rewardCoin)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const timeDuration = computed(() => userStore?.PWAConvertData?.config?.popupDuration)
const pwaID = computed(() => userStore?.PWAConvertData?.config?.Id)
const pwaDomainInfo = computed(() => userStore?.PWAdomainInfo)
const emits = defineEmits(['close', 'success', 'error'])
const params = {
  show,
  contactRef,
  statusRef,
  loadingRef,
  toastContent,
  isSuccess,
  userStore,
  isOpen,
  canReceivedRewards: canRecievedRewards,
  timeDuration,
  pwaID,
  pwaDomainInfo,
  emits,
  t
}


const open = () => openPopup(params)
const close = () => closePopup(params)

const handlePlayStore = () => goToPlayStore(params)
defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background: #221b24;
    border-radius: 25px 25px 0 0;
    width: 100%;
    overflow: hidden;
}

.van-overlay {
    z-index: 9999 !important;
    backdrop-filter: blur(.26667rem);
}

.headBar {
    background-image: url('@/assets/themetwo/Dow_Bg.png');
    background-size: cover;
    background-repeat: repeat;
    padding: 10px;

}

.logo img {
    width: 70%;
    padding: 10px;
}

.text1 {
    font-weight: bold;
    color: #ffffffd9;
    padding-bottom: 10px;
    font-size: 15px;
}

.text2 {
    color: #ffffffa6;
}

.closeIcon {

    display: flex;
    justify-content: right;
}

.closeIcon img {
    width: 25px;
    padding: 2px;
    background-color: #000;
    border-radius: 30px;
}

.bannerImg {
    padding: 5px;
}

.bannerImg img {
    width: 100%;
}

.title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0 5px;
    color: #fff;
}

.detailsBg {
    background: url('@/assets/common/pwa_update_background1.png');
    background-size: cover;
    background-repeat: repeat;
    border: 2px solid #f7d9b5;
    border-radius: 10px;
    padding: 15px 10px;
}

.infoText {
    color: #86718c;
    font-size: 13px;
    text-align: center;
}

.bonusBar {
    position: relative;
    background: linear-gradient(180deg, #522c9c, #af12eb);
    color: #fff;
    border-radius: 30px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 5% 10%;
    font-size: 17px;
}

.floatImage {
    position: fixed;
    right: 8%;
}

.bonusBar span {
    color: #fff;
    font-size: 17px;
}

.bonusBar img {
    width: 30px;
    padding-right: 10px;
}

.floatImage img {
    width: 60px;
    padding: 5px 0 0;
}

.linkBtn {
    background-image: linear-gradient(180deg, #F39A4F 0%, #78340F 100%);
    border: 1.5px solid rgba(249, 196, 134, 1);
    padding: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    color: #FFFFFF;
    font-size: 15px;
    width: 90%;
}

.linkBtn img {
    width: 25px;
    padding-right: 10px;
}

.serviceIcon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.serviceIcon img {
    width: 40%;
    padding: 12px;
    border-radius: 30px;
    background: #00000040;
}

.alignment {
    display: flex;
    justify-content: center;
    align-items: center;
}

.title2 {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding-bottom: 10px;
}

.installInfo {
    color: #86718c;
    font-size: 12px;
    padding: 5px 0; 
}

.introCard{
    background: #312734;
    padding: 10px;
    border-radius: 5px;
}
.title3 {
    color: #fff;
    font-size: 15px;
    padding-bottom: 10px;
}

.installInfo2 {
    color: #86718c;
    font-size: 12px;
}
</style>